// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.antecipacoes-dialog {
    width: 70dvw;
}
.antecipacoes-top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1rem;
}
.antecipacoes-table-button {
    width: 7em;
}
.antecipacao-dialog {
    width: max(480px, min(1200px, 100%));
}
.antecipacao-dados {
    width: 100%;
    border-collapse: collapse;
}
.antecipacao-dados th, .antecipacao-dados td {
    border: 1px solid #ddd;
    padding: 0.5em;
}
.antecipacao-buttongrid {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    margin-bottom: 10px;
}
.antecipacao-buttongrid>div {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.antecipacao-buttongrid button {
    width: 9em;
    height: 4em;
}
.antecipacao-buttongrid p {
    font-size: 0.625em;
    width: 14em;
    text-align: center;
    margin-top: 0.5em;
    margin-bottom: 2em;
}
.antecipacao-avalplantio button {
    margin-right: 1em;
}
.flex-end {
    display: flex;
    justify-content: flex-end;
}
.flex-column {
    display: flex;
    flex-direction: column; 
}
.flex-column>button {
    margin-top: 1em;
}
.document-border {
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 3px;
}
.align-center {
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/Antecipacoes.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".antecipacoes-dialog {\n    width: 70dvw;\n}\n.antecipacoes-top {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-bottom: 1rem;\n}\n.antecipacoes-table-button {\n    width: 7em;\n}\n.antecipacao-dialog {\n    width: max(480px, min(1200px, 100%));\n}\n.antecipacao-dados {\n    width: 100%;\n    border-collapse: collapse;\n}\n.antecipacao-dados th, .antecipacao-dados td {\n    border: 1px solid #ddd;\n    padding: 0.5em;\n}\n.antecipacao-buttongrid {\n    display: flex;\n    justify-content: space-around;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n.antecipacao-buttongrid>div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.antecipacao-buttongrid button {\n    width: 9em;\n    height: 4em;\n}\n.antecipacao-buttongrid p {\n    font-size: 0.625em;\n    width: 14em;\n    text-align: center;\n    margin-top: 0.5em;\n    margin-bottom: 2em;\n}\n.antecipacao-avalplantio button {\n    margin-right: 1em;\n}\n.flex-end {\n    display: flex;\n    justify-content: flex-end;\n}\n.flex-column {\n    display: flex;\n    flex-direction: column; \n}\n.flex-column>button {\n    margin-top: 1em;\n}\n.document-border {\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 3px;\n}\n.align-center {\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
